// extracted by mini-css-extract-plugin
export var active = "bc_bd";
export var arrow = "bc_9";
export var button = "bc_cb";
export var buttonMobile = "bc_dX";
export var column = "bc_b3";
export var columns = "bc_b2";
export var container = "bc_h";
export var description = "bc_dn";
export var disclaimer = "bc_c5";
export var disclaimerButton = "bc_dS";
export var disclaimerContainer = "bc_dZ";
export var disclaimerText = "bc_d2";
export var fadeBottom = "bc_d1";
export var fadeTop = "bc_d0";
export var featureFooter = "bc_dV";
export var footer = "bc_cF";
export var footerMobile = "bc_dW";
export var heading = "bc_G";
export var highlight = "bc_dT";
export var icon = "bc_bw";
export var iconContainer = "bc_b1";
export var left = "bc_bS";
export var padding = "bc_dD";
export var popular = "bc_dC";
export var prefix = "bc_dR";
export var recommend = "bc_dP";
export var recommended = "bc_dQ";
export var right = "bc_bV";
export var section = "bc_b";
export var show = "bc_L";
export var subHeading = "bc_H";
export var suffix = "bc_dz";
export var title = "bc_f";
export var waveContainer = "bc_dY";
export var waveOne = "bc_q";
export var waveThree = "bc_ct";
export var waveTwo = "bc_n";
export var waves = "bc_cs";